/**
 * Product Card – Mobile swipe between primary & secondary image
 * Listens on .product-card--image-wrapper (above the link overlay)
 * Toggles .is-swiped on .product-card--image-inner
 */
(function () {
  var SWIPE_THRESHOLD = 40;

  function initCards() {
    document.querySelectorAll('.product-card--image-wrapper').forEach(function (wrapper) {
      var inner = wrapper.querySelector('.product-card--image-inner');
      if (!inner) return;

      var figures = inner.querySelectorAll('figure');
      if (figures.length < 2) return;

      if (wrapper.dataset.swipeInit) return;
      wrapper.dataset.swipeInit = 'true';

      var startX = 0;
      var startY = 0;
      var tracking = false;

      wrapper.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });

      wrapper.addEventListener('touchmove', function (e) {
        if (!tracking) return;
        var dx = Math.abs(e.touches[0].clientX - startX);
        var dy = Math.abs(e.touches[0].clientY - startY);
        // If horizontal swipe detected, prevent the link from navigating
        if (dx > dy && dx > 10) {
          e.preventDefault();
        }
        // If clearly vertical scrolling, stop tracking
        if (dy > dx && dy > 10) {
          tracking = false;
        }
      }, { passive: false }); // passive: false needed for preventDefault

      wrapper.addEventListener('touchend', function (e) {
        if (!tracking) return;
        var endX = e.changedTouches[0].clientX;
        var diff = startX - endX;

        if (Math.abs(diff) >= SWIPE_THRESHOLD) {
          // Prevent the link click from firing after a swipe
          e.preventDefault();
          if (diff > 0) {
            inner.classList.add('is-swiped');
          } else {
            inner.classList.remove('is-swiped');
          }
        }
        tracking = false;
      }, { passive: false });

      // Also block click on the link when swipe just happened
      var link = wrapper.querySelector('.product-card--image-link');
      if (link) {
        var swipeOccurred = false;

        wrapper.addEventListener('touchend', function () {
          if (Math.abs(startX - (event.changedTouches ? event.changedTouches[0].clientX : startX)) >= SWIPE_THRESHOLD) {
            swipeOccurred = true;
            setTimeout(function () { swipeOccurred = false; }, 300);
          }
        }, { passive: true });

        link.addEventListener('click', function (e) {
          if (swipeOccurred) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, true);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCards);
  } else {
    initCards();
  }

  // Re-init for AJAX / infinite scroll
  var grid = document.querySelector('.collection-products, .product-grid, [data-product-grid]');
  if (grid) {
    new MutationObserver(initCards).observe(grid, { childList: true, subtree: true });
  }
})();

/* ithelps: Bei Optionswechsel (z. B. Farbe) automatisch auf die naechste verfuegbare Variante ausweichen */
(function(){
  function getInputs(fs){return Array.prototype.slice.call(fs.querySelectorAll("input[type=radio]"));}
  function getValues(fs){var s=fs.querySelector("select");return s?Array.prototype.map.call(s.options,function(o){return o.value;}):getInputs(fs).map(function(i){return i.value;});}
  function getValue(fs){var s=fs.querySelector("select");if(s)return s.value;var c=fs.querySelector("input:checked");return c?c.value:null;}
  function setValue(fs,val){var s=fs.querySelector("select");if(s){s.value=val;return;}getInputs(fs).forEach(function(i){if(i.value===val)i.checked=true;});}

  document.addEventListener("change",function(e){
    var el=e.target;
    if(!el||!el.closest)return;
    var picker=el.closest("variant-selects");
    if(!picker||typeof picker.getVariantData!=="function")return;
    var fieldsets=Array.prototype.slice.call(picker.querySelectorAll("fieldset"));
    var changed=fieldsets.indexOf(el.closest("fieldset"));
    if(changed<0||fieldsets.length<2)return;

    var selected=fieldsets.map(getValue);
    var variants=picker.getVariantData()||[];
    var current=variants.find(function(v){return v.options.every(function(o,i){return o===selected[i];});});
    if(current&&current.available)return;

    var best=null,bestScore=Infinity;
    variants.forEach(function(v){
      if(!v.available)return;
      /* gewaehlte Option und alle Optionen davor bleiben fix, nur nachfolgende (z. B. Groesse) werden angepasst */
      for(var k=0;k<=changed;k++){if(v.options[k]!==selected[k])return;}
      var score=0;
      v.options.forEach(function(o,i){
        if(i===changed||o===selected[i])return;
        var vals=getValues(fieldsets[i]),a=vals.indexOf(o),b=vals.indexOf(selected[i]);
        score+=1000+Math.abs(a-b)*2+(a<b?1:0); /* naechstgelegene Groesse, bei Gleichstand die groessere */
      });
      if(score<bestScore){bestScore=score;best=v;}
    });
    if(!best)return;
    best.options.forEach(function(o,i){if(i!==changed)setValue(fieldsets[i],o);});
  },true);
})();